module.exports = __webpack_public_path__ + "static/img/MethodsBanner.47e9779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MethodsBanner.png
// module id = 209
// module chunks = 1